<mat-toolbar color="primary">
    <span class="title-center">{{title}}</span>
</mat-toolbar>
<form *ngIf="configType === 'form'" [formGroup]="paymentConfigForm"
    class="content" fxLayout="column"
    fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px">
    <mat-card fxLayout="column">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <mat-select placeholder="Form*" formControlName="formType">
                    <mat-option value="CC">Charitable Contribution</mat-option>
                    <mat-option value="CG">Community Grants</mat-option>
                    <mat-option value="ES">Event Sponsorship</mat-option>
                    <mat-option value="MG">Matching Gift</mat-option>
                    <mat-option value="PP">Plant For The Planet</mat-option>
                    <mat-option value="CI">Community Investment</mat-option>
                    <mat-option value="FO">LG&E KU Foundation </mat-option>
                    <!-- <mat-option *ngFor="let option of paymentOptions" [value] = "option.paymentOption" [disabled]="!option.isActive"> {{option.paymentOption}}</mat-option> -->
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="Tax Exempt Status*"
                    formControlName="subsection">

                    <mat-option *ngFor="let subsection of taxExemptSubsections"
                        [value]="subsection.subsection">
                        {{getTaxExemptStatus(subsection.subsection)}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <mat-select placeholder="Payment Processor*"
                    formControlName="paymentProcessor"
                    (selectionChange)="onChangeProcessor($event.value)">
                    <mat-option value="OeBS">OeBS</mat-option>
                    <mat-option value="Foundation Trustee">Foundation Trustee</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-select multiple placeholder="Payment Option*"
                    formControlName="paymentOptions">
                    <!-- <mat-option value="Exception">Exception</mat-option>
                    <mat-option value="03">501(c)03</mat-option>
                    <mat-option value="04">501(c)04</mat-option>
                    <mat-option value="06">501(c)06</mat-option>
                    <mat-option value="Other">Other 501(c) Subsection</mat-option> -->
                    <mat-option *ngFor="let option of paymentOptions"
                        [value]="option.paymentOption">
                        {{option.paymentOption}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <mat-card-subtitle fxLayout="row">Approved Requests Start From:</mat-card-subtitle>
                <mat-form-field fxLayout="column">
                    <input matInput [min]="minEffdt"
                        [matDatepicker]="pickerStart" readonly placeholder=""
                        formControlName="startDate">
                    <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
                    <mat-datepicker #pickerStart></mat-datepicker>
                    <mat-hint align="end">choose from dropdown ^</mat-hint>
                </mat-form-field>
            </mat-form-field>
            <mat-form-field>
                <mat-card-subtitle fxLayout="row">Approved Requests End By:</mat-card-subtitle>
                <mat-form-field fxLayout="column">
                    <input matInput [min]="minEffdt" [matDatepicker]="pickerEnd"
                        readonly placeholder=""
                        formControlName="endDate">
                    <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
                    <mat-datepicker #pickerEnd></mat-datepicker>
                    <mat-hint align="end">choose from dropdown ^</mat-hint>
                </mat-form-field>
            </mat-form-field>
        </div>
    </mat-card>

    <div class="buttons" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center
        center">
        <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
        <button mat-raised-button (click)="onSave()" color="primary"
            [disabled]="paymentConfigForm.invalid">Save</button>
    </div>
</form>
<form *ngIf="configType === 'paymentProcessor'"
    [formGroup]="paymentProcessorForm" class="content" fxLayout="column"
    fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="16px">
    <mat-card fxLayout="column">
        <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around
            center">
            <mat-form-field>
                <input type="text" matInput readonly placeholder="Payment
                    Processor" formControlName="paymentProcessor">
            </mat-form-field>
            <mat-form-field>
                <mat-select multiple placeholder="Payment Option"
                    formControlName="paymentOptions">
                    <!-- <mat-option value="Exception">Exception</mat-option>
                    <mat-option value="03">501(c)03</mat-option>
                    <mat-option value="04">501(c)04</mat-option>
                    <mat-option value="06">501(c)06</mat-option>
                    <mat-option value="Other">Other 501(c) Subsection</mat-option> -->
                    <mat-option *ngFor="let option of paymentOptions"
                        [value]="option.paymentOption"
                        [disabled]="!option.isActive"> {{option.paymentOption}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </mat-card>

    <div class="buttons" fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center
        center">
        <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
        <button mat-raised-button (click)="onSave()" color="primary"
            [disabled]="paymentProcessorForm.invalid">Save</button>
    </div>
</form>